module.exports = __webpack_public_path__ + "img/5e2652ba512100481529892078155858.png";